export default __webpack_public_path__ + "static/media/ico-eth-opacity-blue.ba69befd.svg";